import InputRadios from './InputRadios'

export default InputRadios



// WEBPACK FOOTER //
// ./src/components/InputRadios/index.js